import { render, staticRenderFns } from "./GridInformacoesComponent.vue?vue&type=template&id=7d546010"
import script from "./GridInformacoesComponent.vue?vue&type=script&lang=js"
export * from "./GridInformacoesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports